<p-panel header="{{'pages_titles.edit.employee' | translate}}">
    <form [formGroup]="editUserForm">
        <div class="row ml-3 mr-3">
            <div class="block-img col-12 d-flex justify-content-center">
                <img class="avatar" [src]="displayedImage" />
            </div>
            <!-- Image -->
            <button pButton class="p-button-outlined p-button-secondary ml-auto mr-auto mt-3 mb-3" data-toggle="modal"
                data-target="#cropModal">{{'actions.updatePhoto' | translate}}</button>
            <!-- Crop modal -->
            <div class="modal fade" id="cropModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <strong class="modal-title">{{'actions.updatePhoto' | translate}}</strong>
                            <button type="button" status="primary" class="close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="input-photo-mb-5 input-photo-input">
                                <input id="file-upload" class="file-item ml-5" name="photo" formControlName="photo"
                                    type="file" (change)="fileChangeEvent($event)" accept=".png, .jpg, .jpeg" />

                                <label for="file-upload" class="row">
                                    <div class="col-12">
                                        <span class="input-browse"> {{'actions.chooseImage' | translate}} </span>
                                    </div>
                                    <image-cropper class="col-12" [imageChangedEvent]="imageChangedEvent"
                                        [maintainAspectRatio]="false" [aspectRatio]="1 / 1" format="jpg"
                                        [resizeToWidth]="512" (imageCropped)="imageCropped($event)"> </image-cropper>
                                </label>
                            </div>
                        </div>
                        <nb-card-footer>
                            <button class="float-right btn btn-primary" [disabled]="!showButtonEditPhoto"
                                (click)="confirmImage()" aria-label="Close">{{'actions.ValidImage' |
                                translate}}</button>
                            <button class="float-right mr-2 btn btn-light" data-dismiss="modal">{{'actions.cancel' |
                                translate}}</button>
                        </nb-card-footer>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- email -->
                <div class="form-group col-12 col-md-6">
                    <label for="email">{{'Email' | translate}} </label>
                    <input class="w-100" type="email" readonly id="email" name="email" pInputText
                        formControlName="email" [value]="user?.email" />
                </div>

                <!-- username -->
                <div class="form-group col-12 col-md-6">
                    <label for="username">{{'Username' | translate}} </label>
                    <input class="w-100" type="text" readonly id="username" name="username" required pInputText
                        shape="rectangle" formControlName="username"
                        [value]="(user?.username) ? user?.username : ' '" />
                </div>

                <!-- firstName -->
                <div class="form-group col-12 col-md-4">
                    <label for="firstName">{{'First_name' | translate}}</label>
                    <input class="w-100" type="text" id="firstName" name="firstName" pInputText fullWidth
                        formControlName="firstName" [value]="(user?.firstName) ? user?.firstName : 'basic'" />
                </div>


                <!-- lastName -->
                <div class="form-group col-12 col-md-4">
                    <label for="lastName">{{'Last_name' | translate}}</label>
                    <input class="w-100" type="text" id="lastName" name="lastName" pInputText shape="rectangle"
                        formControlName="lastName" [value]="(user?.lastName)? user?.lastName : 'basic'" />
                </div>

                <!-- gender -->
                <div class="form-group col-12 col-md-4">
                    <label for="gender">{{'Gender' | translate}}</label>
                    <p-dropdown appendTo="body" class="d-block" [options]="genders" optionLabel="name"
                        formControlName="gender" placeholder="{{'select' | translate}}"></p-dropdown>
                </div>

                <!-- birthdate -->
                <div class="form-group col-12 col-md-6">
                    <label for="birthdate">{{'Birthdate' | translate}}</label>
                    <p-calendar [style]="{'width':'100%'}" formControlName="birthdate" [showIcon]="true"
                        [maxDate]="maxBirthdate" dateFormat="dd-mm-yy" [showIcon]="true"></p-calendar>
                </div>

                <!-- type -->
                <div class="form-group col-12 col-md-6">
                    <label for="type">{{'Type' | translate}}</label>
                    <p-dropdown appendTo="body" class="d-block" [options]="typesUser" optionLabel="name"
                        formControlName="type" placeholder="{{'select' | translate}}"></p-dropdown>
                </div>

                <!--  locale  -->
                <div class="form-group col-12 col-md-6">
                    <label for="locale">{{'Langue' | translate}}</label>
                    <p-dropdown appendTo="body" class="d-block" [options]="languages" optionLabel="name"
                        formControlName="locale" placeholder="{{'select' | translate}}"></p-dropdown>
                </div>

                <!-- This should be countries importer from the db.countries collection -->
                <div class="form-group col-12 col-md-6">
                    <label for="local">{{'Country' | translate}}</label>
                    <p-dropdown appendTo="body" class="d-block" [options]="countries" optionLabel="name"
                        formControlName="country" placeholder="{{'select' | translate}}"></p-dropdown>
                </div>

                <!-- address -->
                <div class="form-group col-12 col-md-6">
                    <label for="address">{{'Address' | translate}}</label>
                    <input class="w-100" type="text" id="address" name="address" pInputText formControlName="address"
                        [value]="( user?.address && ( user?.address !== 'undefined' ) ) ? user?.address : ' '" />
                </div>

                <!-- city -->
                <div class="form-group col-12 col-md-6">
                    <label for="city">{{'City' | translate}}</label>
                    <input class="w-100" type="text" id="city" name="city" pInputText fullWidth formControlName="city"
                        [value]="(user?.city) ? user?.city : ' '" />
                </div>

                <!-- zip code -->
                <div class="form-group col-12 col-md-6">
                    <label for="zipCode">{{'ZipCode' | translate}}</label>
                    <input class="w-100" type="number" id="zipCode" name="zipCode" pInputText fullWidth
                        formControlName="zipCode" [value]="(user?.zipCode) ? user?.zipCode : ' '" min="0" />
                </div>

                <!-- phone -->
                <div class="form-group col-12 col-md-6">
                    <label for="phoneNumber">{{'Phone' | translate}}</label>
                    <input class="w-100" type="number" id="phoneNumber" name="phoneNumber" pInputText fullWidth
                        formControlName="phoneNumber" [value]="(user?.phoneNumber) ? user?.phoneNumber : ' '" min="0" />
                </div>

                <!-- button edit -->
                <div class="ml-auto mr-auto">
                    <button pButton icon="pi pi-check" iconPos="left" (click)="editEmployee()" type="button"
                        label="{{'actions.update' | translate}}"></button>
                </div>
            </div>
        </div>
    </form>

</p-panel>